import { assert } from "@/helpers/helpers";
import type { Config } from "@/state/types";
import { createContext, useContext } from "react";

export const ConfigContext = createContext<Config | undefined>(undefined);

export function useConfigContext() {
  const res = useContext(ConfigContext);
  assert(res);
  return res;
}
